import { Directive, Input, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  // Attach to BOTH [middleClick] and [routerLink]
  selector: '[middleClick], [routerLink]',
  standalone: true,
})
export class MiddleClickDirective {
  private router = inject(Router);
  // Explicit URL for external/internal navigation
  @Input('middleClick') middleClickUrl?: string;

  // Native Angular router binding
  @Input('routerLink') routerLink?: string | any[];

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event.button !== 1) return; // Only respond to middle click

    let targetUrl: string | undefined;

    if (this.middleClickUrl) {
      // Case 1: Explicit [middleClick]
      targetUrl = this.middleClickUrl;
    } else if (this.routerLink) {
      // Case 2: Auto-apply on [routerLink]
      const urlTree = this.router.createUrlTree(
        Array.isArray(this.routerLink) ? this.routerLink : [this.routerLink]
      );
      targetUrl = this.router.serializeUrl(urlTree);
    }

    if (targetUrl) {
      // Internal route vs external URL
      if (targetUrl.startsWith('/')) {
        window.open(targetUrl, '_blank'); // Internal route
      } else {
        window.open(targetUrl, '_blank'); // External link
      }

      event.preventDefault();
      event.stopPropagation();
    }
  }
}
